module.exports = __webpack_public_path__ + "static/media/software-engineering-cta-background-mobile.62a53f14.png";